module.exports = __webpack_public_path__ + "static/img_1881-4cf9c52cee2233d9a48363eca1713b42.webp";